<template>
      <div>
        Synergy score is calculated as 
        <span class="math-block"><vue-mathjax :formula="'$$LFC_a + LFC_b - LFC_c$$'"></vue-mathjax></span> where
        <span class="math-block"><vue-mathjax :formula="'$$LFC_a$$'"></vue-mathjax></span> and 
        <span class="math-block"><vue-mathjax :formula="'$$LFC_b$$'"></vue-mathjax></span> are the log-fold change in each constituent compound (test compound and anchor compound respectively) and <span class="math-block"><vue-mathjax :formula="'$$LFC_c$$'"></vue-mathjax></span> is the log-fold change in the combination. 
        Synergy score calculations follow the BLISS model, where under the null hypothesis (no interaction between perturbations) the viability effects are multiplicative (LFCs are additive). The synergy score is the difference of the expected value (<span class="math-block"><vue-mathjax :formula="'$$LFC_a + LFC_b$$'"></vue-mathjax></span>)  and the observed (<span class="math-block"><vue-mathjax :formula="'$$LFC_c$$'"></vue-mathjax></span>) value. Large positive values (<span class="math-block"><vue-mathjax :formula="'$$LFC_a + LFC_b > LFC_c$$'"></vue-mathjax></span>) indicate synergy. Large negative values (<span class="math-block"><vue-mathjax :formula="'$$LFC_a + LFC_b < LFC_c$$'"></vue-mathjax></span>) indicate antagonism.
     
      </div>
  </template>
<script>
export default {
    name: "SynergyScoreDetails",
    props:{
    },
    mounted(){
    },
    computed:{

    }
}
</script>


<style scoped>


</style>